import type React from "react";
import { t } from "i18next";
import cx from "classnames";
import { NumberInputField } from "@smartsuite/react-ui/lib";
import {
  AddIntervalButton,
  NumberInputFieldWrapper,
  StyledTitle,
} from "./style";
import { plural } from "../../../../../../../../locales/i18n";
import { useState } from "react";

export const NumberInput: React.FC<{
  onChange: (value: number) => void;
  value?: number;
  disabled: boolean;
  interval?: boolean;
  isTrashEnabled?: boolean;
}> = ({ onChange, value, disabled, interval, isTrashEnabled }) => {
  const [focus, setFocus] = useState<boolean>(false);

  return (
    <NumberInputFieldWrapper value={Number(value)}>
      {interval === true && (
        <AddIntervalButton
          className={cx("add-interval-button", {
            "with-trash": isTrashEnabled,
          })}
        >
          {t("date-editor.interval")}
        </AddIntervalButton>
      )}
      <StyledTitle>+</StyledTitle>
      <NumberInputField
        placeholder={t("date-editor.interval-placeholder")}
        value={value !== undefined ? value.toString() : undefined}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        state={focus ? "active" : undefined}
        autoHideNavigation={true}
        showSymbol={false}
        onChangeValue={(value: string) =>
          !Number.isNaN(Number(value)) && onChange(Number(value))
        }
        suffixText={t(
          plural("date-editor.interval-suffix-text", Number(value)),
        )}
        max="999"
        min="-999"
        inputStyles={{
          backgroundColor: "white",
          borderColor: "G-1-5",
          borderHoverColor: "G-3",
          borderFocusColor: "G-3",
          height: 36,
        }}
        disabled={disabled}
      />
    </NumberInputFieldWrapper>
  );
};
